import { render, staticRenderFns } from "./TagsControl.vue?vue&type=template&id=2ae71775&scoped=true&"
import script from "./TagsControl.vue?vue&type=script&lang=js&"
export * from "./TagsControl.vue?vue&type=script&lang=js&"
import style0 from "./TagsControl.vue?vue&type=style&index=0&id=2ae71775&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ae71775",
  null
  
)

export default component.exports